/* eslint-disable max-classes-per-file */
// @todo - Fix
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './style.css';

export class Radio extends Component {
  render() {
    const { name, selectedValue, onChange } = this.context.radioGroup;
    const { label, className, ...otherProps } = this.props;

    const optional = {};

    if (selectedValue !== undefined) {
      optional.checked = this.props.value === selectedValue;
    }

    if (typeof onChange === 'function') {
      optional.onChange = onChange.bind(null, this.props.value);
    }

    return (
      <Fragment>
        <label className={classnames('radio-container', className)}>
          {label}
          <input
            {...otherProps}
            aria-checked={optional.checked}
            type="radio"
            name={name}
            {...optional}
          />
          <span className="checkmark" />
        </label>
      </Fragment>
    );
  }
}

Radio.contextTypes = {
  radioGroup: PropTypes.object
};

export class RadioGroup extends React.Component {
  getChildContext = () => {
    const { name, selectedValue, onChange } = this.props;

    return {
      radioGroup: {
        name,
        selectedValue,
        onChange
      }
    };
  }

  render() {
    const {
      Component: ComponentFragment, name, selectedValue, onChange, children, ...rest
    } = this.props;

    return (
      <ComponentFragment role="radiogroup" {...rest}>
        {children}
      </ComponentFragment>
    );
  }
}

RadioGroup.defaultProps = {
  Component: 'div'
};

RadioGroup.propTypes = {
  name: PropTypes.string,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  onChange: PropTypes.func,
  children: PropTypes.node.isRequired,
  Component: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
};

RadioGroup.childContextTypes = {
  radioGroup: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/Radio/index.js